import "@/App.css";
import StageManager from "@/components/StageManager";

function App() {
  return <StageManager />;
}

export default App;
